import {AddressType} from "../../../enums";

export class AddressDetailRes {
    public id!: number;
    public type!: AddressType;
    public streetName!: string;
    public streetNumber!: string;
    public city!: string;
    public zipCode!: string;
    public federalState!: string;
    public country!: string;
    public default!: boolean;

    toString(){
        return this.streetName + ' ' + this.streetNumber + ', '+this.zipCode+ ' ' + this.city + ', ' + this.country;
    }
}

export class AddressReq {
    id: number = 0;
    city: string = "";
    country: string = "";
    streetName: string = "";
    streetNumber: string = "";
    zipCode: string = "";
    federalState?: string = "";
    default!: boolean;
    type!: AddressType;

    constructor(addressRes?: AddressDetailRes) {
        if (addressRes !== undefined) {
            this.id = addressRes.id;
            this.city = addressRes.city;
            this.country = addressRes.country;
            this.streetName = addressRes.streetName;
            this.streetNumber = addressRes.streetNumber;
            this.zipCode = addressRes.zipCode;
            this.federalState = addressRes.federalState;
            this.default = addressRes.default;
            this.type = addressRes.type;

        }
    }
}
